import ArrowRightIcon from "../Icon/ArrowRightIcon";
import styles from "./Button.module.css";
interface ButtonProps {
  children?: React.ReactNode;
  type?: "default" | "disabled" | "secondary" | "light" | "blue";
  height?: string;
  width?: string;
  hasArrow?: boolean;
  useContainerWidth?: boolean;
  disabled?: boolean;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  style?: React.CSSProperties;
  size?: "s" | "m" | "l";
  outlined?: boolean;
}
const Button: React.FC<ButtonProps> = ({
  children,
  type = "default",
  width = "",
  height = "",
  className = "",
  hasArrow = false,
  disabled = false,
  size = "m",
  onClick = () => {},
  style = {},
  outlined = false,
  useContainerWidth = false,
}) => {
  if (disabled) {
    type = "disabled";
  }
  if (width) {
    style.width = width;
    style.minWidth = width;
  }
  if (height) {
    style.height = height;
  }
  return (
    <button
      className={`s-button ${styles.button} ${styles[type]} ${styles[size]} 
      ${hasArrow ? styles.hasArrow : ""} 
      ${useContainerWidth ? styles.useContainerWidth : ""}
      ${outlined ? styles.outlined : ""}
      ${className}
      `}
      style={style}
      disabled={type === "disabled" || disabled}
      onClick={e => !(disabled || type === "disabled") && onClick(e)}
    >
      <span className={styles.text}>{children}</span>
      {hasArrow && <ArrowRightIcon size="16px" />}
    </button>
  );
};
export default Button;
